module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['confirm', 'modal', _vm.legal ? 'legal' : '']
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.decline
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce-in"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "modal-content"
  }, [(_vm.legal) ? _c('div', {
    staticClass: "too-small"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('confirm.legal.too_small')) + "\n                "), _c('action', {
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.okay')))])], 1) : _vm._e(), _vm._v(" "), (_vm.headline !== '') ? _c('div', {
    staticClass: "head"
  }, [_c('h2', [_vm._v("\n                    " + _vm._s(_vm.headline) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.legal) ? _c('div', {
    staticClass: "legal-body"
  }, [_c('div', {
    staticClass: "legal-content"
  }, [_c('div', {
    staticClass: "scroll-notice"
  }, [_vm._v(_vm._s(_vm.$t('confirm.legal.scroll_notice')))]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.content.iframe + '?' + _vm.hash,
      "width": "100%",
      "height": "100%",
      "scrolling": "yes"
    }
  })]), _vm._v(" "), (!_vm.content.accepted) ? _c('div', {
    staticClass: "legal-statement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmed),
      expression: "confirmed"
    }],
    attrs: {
      "type": "checkbox",
      "value": "yes",
      "name": "confirmation",
      "id": "confirmation"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirmed) ? _vm._i(_vm.confirmed, "yes") > -1 : (_vm.confirmed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirmed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "yes",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirmed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirmed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirmed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirmation"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('confirm.legal.statement.0', {
        name: _vm.$store.state.current.user.name
      }))
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('confirm.legal.statement.1')))]), _vm._v(" "), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('confirm.legal.statement.2', {
        company: _vm.$store.state.current.account.name
      }))
    }
  }), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('confirm.legal.statement.3')))])])])]) : _vm._e()]) : [(_vm.html && _vm.content) ? _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.html && _vm.content) ? _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                    " + _vm._s(_vm.content) + "\n                ")]) : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.legal && _vm.content.print) ? _c('action', {
    staticClass: "left",
    attrs: {
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.print.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('label.print')) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.legal || (_vm.legal && !_vm.content.accepted)) ? _c('action', {
    attrs: {
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.labelConfirm) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.legal || (_vm.legal && !_vm.content.accepted)) ? _c('action', {
    attrs: {
      "color": "transparent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.decline.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.labelDecline) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.legal && _vm.content.accepted) ? _c('action', {
    nativeOn: {
      "click": function($event) {
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('common.button.close')) + "\n                ")]) : _vm._e()], 1)], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4b42c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Confirm.vue
// module id = 469
// module chunks = 234